// Import Sass
import './sass/adults.scss';

// Import JS
import './js/adults';
